/**
 * Builds component CSS class
 *
 * @param {string} prefix
 * @param {string} width
 * @param {string} isTouched
 * @param {string} hasError
 * @param {string} highlighted
 * @returns {string}
 */
const generateStyle = (prefix, width, isTouched, hasError, highlighted) => {
    let classArray = [prefix];
    classArray.push(width && `size--${width}`);
    classArray.push(highlighted && `${prefix}--highlight`);

    if (isTouched) {
        classArray.push((hasError ? `${prefix}--invalid` : `${prefix}--valid`));
    }
    else if (!isTouched && hasError) {
        classArray.push(`${prefix}--invalid`);
    }

    classArray = classArray.filter(Boolean);
    return classArray.join(' ');
}
export { generateStyle };